var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Campaign-Ads-placeholder"},[_vm._v("\n  "+_vm._s(_vm.$t('ads_placeholder'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }